const fabricOrLeatherOptions = ['FG1', 'FG2', 'FG3', 'FG4', 'FG5', 'FG6', 'LG1', 'LG2', 'LG3', 'LG4', 'LG5', 'LG6', 'COM Fabric', 'COM Leather', 'Other Options'];

class OptionSelectorSlideout extends SlideoutModal {
  constructor() {
    super();

    // selectors
    this.selectors = {
      variantOption: '.variant-input',
      backButton: '.header__inner-box .u-btn--previous',
      proceedButton: '.proceed-btn',
      materialCodeInput: '[data-code-input]',
      variantDetailSwatch: '.option-detail-swatch'
    };

    // classes
    this.classes = {
      variantOptionHidden: 'variant-input--hidden',
      backButtonHidden: 'u-btn--hidden'
    };

    this.actionButton = this.footerEle.querySelector(this.selectors.proceedButton);

    // Back button
    this.backButton = this.querySelector(this.selectors.backButton);

    this.variantDetailSwatches = this.querySelectorAll(this.selectors.variantDetailSwatch + ' input[type="radio"]');

    this.init();
  }

  init() {
    if(this.backButton) {
      this.backButton.addEventListener('click', this.backButtonClickHandler.bind(this));
    }

    if(this.actionButton) {
      this.actionButton.addEventListener('click', this.proceedButtonClickHandler.bind(this));
    }

    document.addEventListener('variant:change', this.variantChangeHandler.bind(this));

    this.addEventListener('modal:closed', this.onCloseHandler.bind(this));

    if(this.variantDetailSwatches && this.variantDetailSwatches.length) {
      this.variantDetailSwatches.forEach(el => {
        el.addEventListener('click', () => {
          const parentContainer = el.closest('.option-detail-swatch');
          const dataAttrs = parentContainer.dataset.optionRef.split(' / ');
          const parentVariantOption = document.querySelector(`.variant-input[data-index="${dataAttrs[0]}"][data-value="${dataAttrs[1]}"] input[type="radio"]`);
          if(!parentVariantOption.checked) {
            parentVariantOption.checked = true;
            parentVariantOption.dispatchEvent(new Event('change'));
          }
        })
      })
    }
    window.addEventListener("dataProcessed", () => {
      this.onCloseHandler();
    });
  }

  backButtonClickHandler(evt) {
    evt.preventDefault();
      
    this.backButton.classList.add(this.classes.backButtonHidden);

    const variantOptionElements = this.querySelectorAll(this.selectors.variantOption);
    variantOptionElements.forEach(ele => ele.classList.remove(this.classes.variantOptionHidden));
  }

  proceedButtonClickHandler(e) {
    e.preventDefault();
    this.close();
  }

  onCloseHandler() {
    try {
      const selectedValueEle = document.querySelector(`.selected-option[data-ref="${this.id}"]`);
      const optionBoxEle = selectedValueEle.closest('.option-box');
      const selectedVariantOption = this.querySelector('.variant-wrapper .variant-input input[type="radio"]:checked');

      selectedValueEle.setAttribute('data-title', '');
      selectedValueEle.classList.remove('has-tooltip');

      if(selectedVariantOption) {
        selectedValueEle.innerHTML = selectedVariantOption.value;
        optionBoxEle.classList.remove('option-box--unselected');
      } else {
        selectedValueEle.innerHTML = '<span>Select Option</span>';
        optionBoxEle.classList.add('option-box--unselected');
        return;
      }
      // selectedValueEle.innerHTML = selectedVariantOption ? selectedVariantOption.value : '<span>Select Option</span>';

      // if(!selectedVariantOption) return;
      const parentVariantInputEle = selectedVariantOption.closest('.variant-input');
      const optionRef = `${parentVariantInputEle.dataset.index} / ${parentVariantInputEle.dataset.value}`;
      const variantOptionDetailWrapper = this.querySelector(`[data-option-ref='${optionRef}']`);

      if(variantOptionDetailWrapper) {
        if(variantOptionDetailWrapper.querySelector('input[type="radio"]')) {
          const checkedSubOption = variantOptionDetailWrapper.querySelector('input[type="radio"]:checked');
          if(checkedSubOption) {
            selectedValueEle.setAttribute('data-title', checkedSubOption.value);
            selectedValueEle.classList.add('has-tooltip');
          }
        } else {
          const materialCodeEle = this.querySelector(this.selectors.materialCodeInput);
          if(materialCodeEle && materialCodeEle.value.length) {
            selectedValueEle.setAttribute('data-title', materialCodeEle.value);
            selectedValueEle.classList.add('has-tooltip');
          } 
        }
      } else if(selectedVariantOption.value === 'COM Fabric' || selectedVariantOption.value === 'COM Leather') {
        const materialCodeEle = this.querySelector(this.selectors.materialCodeInput);
        if(materialCodeEle && materialCodeEle.value.length) {
          selectedValueEle.setAttribute('data-title', materialCodeEle.value);
          selectedValueEle.classList.add('has-tooltip');
        }
      }
    } catch(e){
      console.log('err', e)
    }
  }

  variantChangeHandler(e) {
    if(this.isClosed()) return;
    
    const {
      variant,
      currentlySelectedValues,
      value: currentOptionValue,
      index,
    } = e.detail;

    const materialCodeInputEle = this.querySelector(this.selectors.materialCodeInput);
    // get allowed options values for material code input
    const allowedOptionValues = materialCodeInputEle?.dataset?.allowedValues;

    if(allowedOptionValues) {
      materialCodeInputEle.value = '';
      if(allowedOptionValues.includes(currentOptionValue)) {
        //material-code-input
        materialCodeInputEle.closest('.material-code-input').classList.remove('hidden');
        materialCodeInputEle.focus();
      } else {
        materialCodeInputEle.closest('.material-code-input').classList.add('hidden');
        materialCodeInputEle.dispatchEvent(new Event('change'));
      }
    }

    // TOGGLE BACK BUTTON
    if(fabricOrLeatherOptions.includes(currentOptionValue)) {
      this.backButton.classList.toggle(this.classes.backButtonHidden);
    }

    // BRING FORWARD SELECTED OPTION
    if(fabricOrLeatherOptions.includes(currentOptionValue)) {
      const selectedVariantOptionElement = this.querySelector(`${this.selectors.variantOption}[data-index="${index}"][data-value="${currentOptionValue}"]`);
      this.querySelectorAll(this.selectors.variantOption).forEach((variantOptionEle) => {
        if(variantOptionEle !== selectedVariantOptionElement) {
          variantOptionEle.classList.add(this.classes.variantOptionHidden);
        } else {
          variantOptionEle.classList.remove(this.classes.variantOptionHidden)
        }
      });
    }
  }

  validate() {
    const response = {
      valid: true,
      feedback: ''
    };

    if(!document.querySelector('[data-customer-logged-in]')) {
      return response;
    }
    try {
      const selectedVariantOption = this.querySelector('.variant-wrapper .variant-input input[type="radio"]:checked');

      const parentVariantInputEle = selectedVariantOption.closest('.variant-input');
      const optionRef = `${parentVariantInputEle.dataset.index} / ${parentVariantInputEle.dataset.value}`;
      const variantOptionDetailWrapper = this.querySelector(`[data-option-ref="${optionRef}"]`);

      
      if(variantOptionDetailWrapper) {
        if(variantOptionDetailWrapper.querySelector('input[type="radio"]')) {
          const checkedSubOption = variantOptionDetailWrapper.querySelector('input[type="radio"]:checked');
          if(!checkedSubOption) {
            response.valid = false;
            response.feedback = 'Please select a material option.';
          }
        } else {
          const materialCodeEle = this.querySelector(this.selectors.materialCodeInput);
          if(materialCodeEle) {
            if(!materialCodeEle.value.length) {
              response.valid = false;
              response.feedback = 'Please enter the material name and code.';
              materialCodeEle.focus();
            }
          } 
        }
      } else if(selectedVariantOption.value === 'COM Fabric' || selectedVariantOption.value === 'COM Leather') {
        const materialCodeEle = this.querySelector(this.selectors.materialCodeInput);
        if(materialCodeEle) {
          if(!materialCodeEle.value.length) {
            response.valid = false;
            response.feedback = 'Please enter the material name and code.';
            materialCodeEle.focus();
          }
        } 
      }
    } catch(e) {}
    
    return response;
  }
}

customElements.define('option-selector-slideout', OptionSelectorSlideout);
